export const getUserRole=(user)=>{
    return  user && user?.id && user?.attributes?.profile?.publicData?.userRole 
  }

export const getUserDisplayInfo = (user) => {
  const firstName = user?.attributes?.profile?.firstName || '';
  const lastName = user?.attributes?.profile?.lastName || '';
  const fullName = `${firstName}${firstName && lastName ? ' ' : ''}${lastName}`.trim() || null;

  const email = user?.attributes?.email || null;

  // Use bracket notation for hyphenated variant keys
  const variants = user?.profileImage?.attributes?.variants;
  const imageUrl =
    variants?.['square-small']?.url ||
    variants?.['square-small2x']?.url ||
    variants?.['square-xsmall']?.url ||
    variants?.['square-xsmall2x']?.url ||
    null;

  return { fullName, email, imageUrl };
};  